<template>
	<article class="post-article-block block" :class="'type-' + data.type" v-if="data">
		<component :is="wrapperComponent" class="post-link" :url="data.link" :title="data.title">
			<WpImage
				size="medium_large"
				class="featured"
				v-if="featuredImage"
				:image="featuredImage"
				cover
				background
			/>
			<div v-else class="featured dummy-image"><div class="img"></div></div>
			<div class="inner">
				<h3 class="titler">{{ data.title }}</h3>
				<span class="cat-indi" v-if="categories" v-html="categories"></span>
				<template v-if="data.acf && data.type === 'person'">
					<span class="meta-info positon" v-if="data.acf.position" v-text="data.acf.position"></span>
					<a
						class="meta-info email"
						v-if="data.acf.email"
						v-text="data.acf.email"
						:href="`mailto:${data.acf.email}`"
					></a>
					<a
						class="meta-info phone"
						v-if="data.acf.phone"
						v-text="data.acf.phone"
						:href="`tel:${data.acf.phone.phoneFormat()}`"
					></a>
				</template>
			</div>
		</component>
	</article>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import WpLink from '@/components/elements/WpLink'

export default {
	name: 'post-block',
	props: {
		data: {
			type: Object,
			default: {},
		},
	},
	data() {
		return {
			featuredImage: null,
		}
	},
	components: {
		WpImage,
		WpLink,
	},
	computed: {
		wrapperComponent() {
			return this.data.type === 'person' ? 'div' : 'WpLink'
		},
		categories() {
			// in this case this is not array, we're using single category logic
			let cats = this.data.acf && this.data.acf.category ? this.data.acf.category : false

			if (cats) {
				return cats.name
			} else {
				return null
			}
			//return formatOutputValues(cats)
		},
	},
	mounted() {
		if (!this.data) return

		if (this.data.featured_image && this.data.featured_image.id) {
			this.featuredImage = this.data.featured_image
		} else if (this.data.acf.photo && this.data.acf.photo.id) {
			this.featuredImage = this.data.acf.photo
		}
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.post-article-block {
	&.type-person {
		.post-link {
			.image,
			.img {
				padding-bottom: 120% !important;
			}
			.inner {
				padding: 20px;
				text-overflow: ellipsis;
			}

			.titler {
				flex: unset;
				margin-bottom: 5px;
				@include fluid-type($smallResText, $wideResText, 16px, 20px);
			}

			.meta-info {
				margin-top: 8px;
				@include fluid-type($smallResText, $wideResText, 14px, 16px);
			}
		}
	}

	.wp-image-vue .image {
		@include transition(opacity, 0.15s);
		background-color: var(--dark);
	}

	.post-link {
		background-color: var(--gray);
		display: block;
		text-decoration: none;
		overflow: hidden;
		height: 100%;
		display: flex;
		flex-direction: column;
		box-shadow: inset 0 0 0 2px transparent;
		transition: box-shadow 0.2s ease-in-out;
		&:hover {
			box-shadow: inset 0 0 0 2px var(--dark);
			.wp-image-vue .image {
				opacity: 0.75 !important;
			}
		}
		.cat-indi {
			@include fluid-type($smallResText, $wideResText, 12px, 15px);
		}
		.titler {
			margin: 0;
			font-weight: 400;
			flex: 1;
			margin-bottom: 25px;
			@include fluid-type($smallResText, $wideResText, 16px, 22px);
		}
		.inner {
			padding: 25px;
			display: flex;
			flex-direction: column;
			flex: 1;
		}
	}
	.dummy-image .img {
		height: 0;
		background-color: #dedede;
		padding-bottom: 56.4%;
	}
}
</style>
